module.exports = __webpack_public_path__ + "img/404.803c3242.svg";